import React, { use, useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import Pagination from 'components/Common/newPagination';
import metaDataServices from '../MetaDataServices';


export default function AssociatedTrackRelease(param: any) {

    let [SelectedList, setSelectedList] = useState<any>([]);
    let [applyToAllTracks, setapplyToAllTracks] = useState(false);
    let [AssociatedReleaseList, setAssociatedReleaseList] = useState<any>([]);

    useEffect(() => {
        apiCall();
    }, []);

    const closeDrawer = () => { param.onChangAssociatedRelease(); }

    const apiCall = () => {

        metaDataServices.associatedReleasesWithexclusion({ contractRefNum: param?.contract, isrcCode: param?.AssociatedReleaseSelected?.iSRC }).then((respond: any) => {
            AssociatedReleaseList = respond
            setAssociatedReleaseList(AssociatedReleaseList)
        })
    }

    const updateList = (valueSelect: any) => {
        console.log(valueSelect.barcodeNum)

        var index = AssociatedReleaseList?.findIndex((values: any) => values.barcodeNum == valueSelect.barcodeNum)

        AssociatedReleaseList[index].isExcludedUI = !AssociatedReleaseList[index]?.isExcludedUI;
        setAssociatedReleaseList(AssociatedReleaseList)

        SelectedList = valueSelect
        setSelectedList(SelectedList)
        console.log(AssociatedReleaseList)
    }

    const saveAssociatedReleases = () => {
        var payload = {

            applyToAllTracks: applyToAllTracks,
            associatedReleases: SelectedList,
            contractRefNum: param?.contract,
            isrcCode: param?.AssociatedReleaseSelected?.iSRC
        }

        console.log(payload)

        metaDataServices.associatedReleasesWithexclusion(payload).then((respond :any) =>{
            apiCall();
        })
    }

    return (<>

        <Drawer open={param.AssociatedReleaseOpen} onClose={closeDrawer} direction='right' className='react-drawer allowHscroll allowVscroll full-height-vh140' size={800}>

            <div className="box ws-6 pull-right landing">
                <div className="ws-12  pts">
                </div>

                <div className='ws-12 pm'>

                    <fieldset className="scheduler-border p0 m0">
                        <legend className="scheduler-border">
                            <h2 style={{ color: "#47529d" }} > Track Info</h2>
                        </legend>

                        <div className="ws-12">

                            <div className="ws-6">
                                <div className="form-format">
                                    <label className="control-label ws-2 text-right pr"> ISRC : </label>
                                    <div className="text-m ws-10">  {param?.AssociatedReleaseSelected?.iSRC}  </div>
                                </div>
                            </div>

                            <div className="ws-6">
                                <div className="form-format">
                                    <label className="control-label ws-5 text-right pr"> Contract Ref No. :  </label>
                                    <div className="text-m ws-7">  {param?.AssociatedReleaseSelected?.contractRefNum}   </div>
                                </div>
                            </div>

                            <div className="ws-6">
                                <div className="form-format">
                                    <label className="control-label ws-2 text-right pr">  Artist : </label>
                                    <div className="text-m ws-10">   {param?.AssociatedReleaseSelected?.kontactName}   </div>
                                </div>
                            </div>

                            <div className="ws-6">
                                <div className="form-format">
                                    <label className="control-label ws-2 text-right pr"> Title :  </label>
                                    <div className="text-m ws-10">  {param?.AssociatedReleaseSelected?.trackName}   </div>
                                </div>
                            </div>

                        </div>

                    </fieldset>

                </div>

                <div className='ws-12 pm'>
                    {(AssociatedReleaseList?.length > 0) && <table className='NewTable'>
                        <thead>
                            <tr>
                                <th>Don't Pay</th>
                                <th>UPC</th>
                                <th>ISC</th>
                                <th>Release</th>
                                <th>Title</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                AssociatedReleaseList?.map((values: any) => {

                                    return (
                                        <tr>
                                            <td><input type="checkbox" checked={values?.isExcludedUI} onChange={() => {
                                                updateList(values);
                                            }} /></td>
                                            <td>{values?.barcodeNum ?? ""}</td>
                                            <td>{values?.id == 1 ? values?.isrcCode : ""}</td>
                                            <td>{values?.releaseCode ?? ""}</td>
                                            <td>{values?.releaseTitle ?? ""}</td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>}

                    <div className="row-fluid mt" ng-show="associatedReleaseDetails.getTotalItems() &gt; 0">
                        <div className="span4">
                            <label>
                                <input data-ng-model="applyToAllTracks" type="checkbox" checked={applyToAllTracks} onChange={() => setapplyToAllTracks(!applyToAllTracks)} /> Apply to all tracks on this Contract
                            </label>
                        </div>
                    </div>
                </div>

                <div className="ws-12 pm">
                    <button className="icon-btn delete width80 height35 pull-right" onClick={closeDrawer}>Close  </button>
                    <button className="icon-btn edit width80 height35 pull-right" onClick={saveAssociatedReleases}>Save  </button>
                    <button className="icon-btn delete width80 height35 pull-right" onClick={apiCall}>Refresh  </button>
                </div>

            </div>

        </Drawer>
    </>)
}